import {
  VIDEO_STATES,
  type VideoMetaData,
  type VideoMetrics,
  DEFAULT_ELAPSED_TIME,
} from '../../../_shared/Video/types';

export const getStalledRatioOverPlaybackTime = (metrics: VideoMetrics): number => {
  return (
    metrics[VIDEO_STATES.STALLED].elapsedTime / (metrics[VIDEO_STATES.PLAYING].elapsedTime || DEFAULT_ELAPSED_TIME)
  );
};

export const getStalledRatioOverDuration = (metrics: VideoMetrics, metadata: VideoMetaData): number => {
  return metrics[VIDEO_STATES.STALLED].elapsedTime / metadata.duration;
};

export const getTotalStalledTime = (metrics: VideoMetrics): number => {
  return metrics[VIDEO_STATES.STALLED].elapsedTime;
};

export const getTimesStalled = (metrics: VideoMetrics): number => {
  return metrics[VIDEO_STATES.STALLED].count;
};

export const getPlaybackTime = (metrics: VideoMetrics): number => {
  return metrics[VIDEO_STATES.PLAYING].elapsedTime;
};
